import {Component, EventEmitter, Input, Output} from '@angular/core';
import {isNullOrUndefined} from 'util';
export class DualPickListComponent {
     textKeyLeftList: string;
     textKeyRightList: string;
     list: Array<any>;
     placeHolder: string;
     headerConfig: any;

     onTransaction = new EventEmitter<any>();


    itemsLeft: Array<any>;
    itemsRight: Array<any>;

    headerLeft: Array<any>;
    headerRight: Array<any>;

    filterLeftBy:string;
    filterRightBy:string;
constructor(){
    }
private dispatchTransaction = ()=>{
        let /** @type {?} */ left = this.itemsLeft.map((i=>{
            let { left, right, isSelected, ...rest } = i;
            return rest;
        }));

        let /** @type {?} */ right = this.itemsRight.map((i=>{
            let { left, right, isSelected, ...rest } = i;
            return rest;
        }));

        this.onTransaction.emit({
            leftList :left,
            rightList:right
        })

    };
/**
 * @return {?}
 */
ngOnInit(){
        this.itemsLeft = [...this.list.filter(i=>i.left)].map(it=>{return{...it, isSelected:false} });
        this.itemsRight = [...this.list.filter(i=>i.right)].map(it=>{return{...it, isSelected:false} });
        this.headerLeft = [...this.headerConfig.left].filter(i=>!i.hidden || isNullOrUndefined(i.hidden));
        this.headerRight = [...this.headerConfig.right].filter(i=>!i.hidden || isNullOrUndefined(i.hidden));

        this.filterLeftBy  = this.headerLeft[0].key;
        this.filterRightBy = this.headerRight[0].key;

    }
/**
 * @param {?} objChange
 * @return {?}
 */
ngOnChanges(objChange){
        if(objChange.list){
            this.itemsLeft = [...objChange.list.currentValue.filter(i=>i.left)].map(it=>{return{...it, isSelected:false} });
            this.itemsRight = [...objChange.list.currentValue.filter(i=>i.right)].map(it=>{return{...it, isSelected:false} });
        }
        if(objChange.headerConfig){
            this.headerLeft = [...objChange.headerConfig.currentValue.left].filter(i=>!i.hidden || isNullOrUndefined(i.hidden));
            this.headerRight = [...objChange.headerConfig.currentValue.right].filter(i=>!i.hidden || isNullOrUndefined(i.hidden));
        }

    }
/**
 * @param {?} data
 * @return {?}
 */
getTransactionFromLeft(data){
        this.itemsRight = this.itemsRight.concat(data.toMove).map(i=>{return{...i, isSelected:false, left:false, right:true}});
        this.itemsLeft = data.notMove.map(it=>it);
        this.dispatchTransaction();
    }
/**
 * @param {?} data
 * @return {?}
 */
getTransactionFromRight(data){
        this.itemsLeft = this.itemsLeft.concat(data.toMove).map(i=>{return{...i, isSelected:false, left:true, right:false}});
        this.itemsRight = data.notMove.map(it=>it);
        this.dispatchTransaction();


    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'app-dual-pick-list',
    template: `
      <div class="bootstrap-duallistbox-container">
          <div class="col-md-6">
              <app-pick-list [position]="'right'" [textLabel]="textKeyLeftList" [list]="itemsLeft" [placeHolder]="placeHolder" [headerConfig]="headerLeft" (onTransaction)="getTransactionFromLeft($event)"></app-pick-list>
          </div>
          <div class="box2 col-md-6">
              <app-pick-list [position]="'left'" [textLabel]="textKeyRightList" [list]="itemsRight" [placeHolder]="placeHolder" [headerConfig]="headerRight" (onTransaction)="getTransactionFromRight($event)"></app-pick-list>
          </div>

      </div>
    `,
    styles: [`

    `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'textKeyLeftList': [{ type: Input },],
'textKeyRightList': [{ type: Input },],
'list': [{ type: Input },],
'placeHolder': [{ type: Input },],
'headerConfig': [{ type: Input },],
'onTransaction': [{ type: Output },],
};
}

function DualPickListComponent_tsickle_Closure_declarations() {
/** @type {?} */
DualPickListComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DualPickListComponent.ctorParameters;
/** @type {?} */
DualPickListComponent.propDecorators;
/** @type {?} */
DualPickListComponent.prototype.textKeyLeftList;
/** @type {?} */
DualPickListComponent.prototype.textKeyRightList;
/** @type {?} */
DualPickListComponent.prototype.list;
/** @type {?} */
DualPickListComponent.prototype.placeHolder;
/** @type {?} */
DualPickListComponent.prototype.headerConfig;
/** @type {?} */
DualPickListComponent.prototype.onTransaction;
/** @type {?} */
DualPickListComponent.prototype.itemsLeft;
/** @type {?} */
DualPickListComponent.prototype.itemsRight;
/** @type {?} */
DualPickListComponent.prototype.headerLeft;
/** @type {?} */
DualPickListComponent.prototype.headerRight;
/** @type {?} */
DualPickListComponent.prototype.filterLeftBy;
/** @type {?} */
DualPickListComponent.prototype.filterRightBy;
/** @type {?} */
DualPickListComponent.prototype.dispatchTransaction;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
